import React, {useCallback} from 'react';
import {
  Avatar,
  DefaultThemeConfig,
  Layout,
  Radio,
  Ruler,
  Spacer,
  Text,
  ThemeContext,
  useThemeProvider,
} from '@di-nxt/components';
import {Appearance} from '../../../services/entities/local/settings/types';
import {t} from '../../../localization';

type AppearanceSelectorProps = {
  onPress: (t: Appearance) => void;
  selected: Appearance;
  firstname: string;
  lastname: string;
};

export const AppearanceSelector: React.FC<AppearanceSelectorProps> = ({
  onPress,
  selected,
  firstname,
  lastname,
}) => {
  const handlechangeDarkmodeAuto = useCallback(() => {
    onPress('Auto');
  }, [onPress]);
  const handlechangeDarkmodeDay = useCallback(() => {
    onPress('Day');
  }, [onPress]);
  const handlechangeDarkmodeNight = useCallback(() => {
    onPress('Night');
  }, [onPress]);

  return (
    <Layout
      width={462}
      padding="18"
      height={360}
      vertical
      borderWidth="1"
      borderColor="border_mono_10"
      borderRadius="16"
      borderStyle="solid">
      <Layout
        justify="space-between"
        align="center"
        onPress={handlechangeDarkmodeDay}>
        <Layout centered>
          <Radio checked={selected === 'Day'} />
          <Spacer width="10" />
          <Text variant="inline_14_default">
            {t('dialogs.settings.general.darkmodeselector.day')}
          </Text>
        </Layout>
        <ThemeContext.Provider
          value={useThemeProvider('day', DefaultThemeConfig)}>
          <Layout
            centered
            vertical
            borderRadius="8"
            width={143}
            height={108}
            borderColor="border_mono_10"
            backgroundColor="background_mono_primary"
            borderStyle="solid"
            borderWidth="1">
            <Avatar name={`${firstname} ${lastname}`} />
            <Text variant="inline_14_emphasis">
              {t('dialogs.settings.general.darkmodeselector.hello', {
                firstname: firstname,
              })}
            </Text>
          </Layout>
        </ThemeContext.Provider>
      </Layout>
      <Spacer height="16" />
      <Ruler horizontal width="1" />
      <Spacer height="16" />
      <Layout
        justify="space-between"
        align="center"
        onPress={handlechangeDarkmodeNight}>
        <Layout centered>
          <Radio checked={selected === 'Night'} />
          <Spacer width="10" />
          <Text variant="inline_14_default">
            {t('dialogs.settings.general.darkmodeselector.night')}
          </Text>
        </Layout>
        <ThemeContext.Provider
          value={useThemeProvider('night', DefaultThemeConfig)}>
          <Layout
            centered
            vertical
            borderRadius="8"
            width={143}
            height={108}
            borderColor="border_mono_10"
            backgroundColor="background_mono_primary"
            borderStyle="solid"
            borderWidth="1">
            <Avatar name={`${firstname} ${lastname}`} />
            <Text variant="inline_14_emphasis">
              {t('dialogs.settings.general.darkmodeselector.hello', {
                firstname: firstname,
              })}
            </Text>
          </Layout>
        </ThemeContext.Provider>
      </Layout>
      <Spacer height="16" />
      <Ruler horizontal width="1" />
      <Spacer height="16" />
      <Layout align="center" onPress={handlechangeDarkmodeAuto}>
        <Layout centered>
          <Radio checked={selected === 'Auto'} />
          <Spacer width="10" />
          <Layout vertical>
            <Text variant="inline_14_default">
              {t('dialogs.settings.general.darkmodeselector.auto.title')}
            </Text>
            <Text variant="paragraph_12_default">
              {t('dialogs.settings.general.darkmodeselector.auto.content')}
            </Text>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};
